'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _discussions = require('../api/discussions');

/**
 *
 */
var messages = {
	'vtChat.Chat.title': 'Chat',
	'vtChat.Chat.discussions': '\n\t\t{status, select,\n\t\t\t' + _discussions.Status.OPEN + ' {Discussions ouvertes}\n\t\t\t' + _discussions.Status.CLOSED + ' {Discussions fermées}\n\t\t\t' + _discussions.Status.PENDING + ' {Discussions en attente}\n\t\t\tother {}\n\t\t}\n\t',

	'vtChat.DiscussionCardList.title': 'Discussions',

	'vtChat.DiscussionCard.action.open': 'Ouvrir',
	'vtChat.DiscussionCard.action.close': 'Fermer',

	'vtChat.Discussion.title': 'Discussion sur {subject}',
	'vtChat.Discussion.statusMessage': '\n\t\t{status, select,\n\t\t\t' + _discussions.Status.OPEN + ' {}\n\t\t\t' + _discussions.Status.CLOSED + ' {Cette discussion est fermée.}\n\t\t\t' + _discussions.Status.PENDING + ' {\n\t\t\t\tCette discussion n\'est pas encore ouverte.\n\t\t\t\tVeuillez patienter jusqu\'à ce que votre interlocuteur soit disponible.\n\t\t\t}\n\t\t\tother {}\n\t\t}\n\t',

	'vtChat.MessageForm.message.title': 'Message',
	'vtChat.MessageForm.message.placeholder': 'Message...',
	'vtChat.MessageForm.submit': 'Envoyer',

	'vtChat.Message.author': '{firstName} {lastName} : '
};

exports.default = messages;